
        var result = require("!!../../../../node_modules/css-loader/index.js!./article-info.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/management/article-info/article-info.component.css
// module id = 2504
// module chunks = 1